/**
 * 书架书籍卡片/列表项模板模块
 */

export function createBookCard(book, options = {}) {
  const progress = Number(book?.progress ?? 0) || 0;
  const circumference = 2 * Math.PI * 14;
  const offset = circumference - (progress / 100) * circumference;

  const isSelectMode = Boolean(options?.isSelectMode);
  const selectedBookIds = options?.selectedBookIds;
  const isSelected = selectedBookIds instanceof Set
    ? selectedBookIds.has(book?.id)
    : Array.isArray(selectedBookIds)
      ? selectedBookIds.includes(book?.id)
      : false;

  const coverHtml = book?.cover
    ? `<img src="${book.cover}" alt="${book.title}" class="book-cover" loading="lazy">`
    : `<div class="book-cover-placeholder">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/>
        </svg>
        <span>${book?.title || ''}</span>
      </div>`;

  const progressRing = progress > 0 ? `
    <div class="book-progress-ring">
      <svg width="36" height="36">
        <circle class="progress-bg" cx="18" cy="18" r="14"/>
        <circle class="progress-value" cx="18" cy="18" r="14"
          stroke-dasharray="${circumference}"
          stroke-dashoffset="${offset}"/>
      </svg>
      <span>${progress}</span>
    </div>
  ` : '';

  return `
    <article class="book-card ${isSelectMode ? 'selectable' : ''} ${isSelected ? 'selected' : ''}" data-id="${book?.id}">
      ${coverHtml}
      ${progressRing}
      <div class="book-actions">
        <button class="book-action-btn info-book-btn" data-id="${book?.id}" title="详情">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 16v-4M12 8h.01"/>
          </svg>
        </button>
      </div>
      <div class="book-info">
        <h3 class="book-title">${book?.title || ''}</h3>
        <div class="book-meta">
          <p class="book-author">${book?.author || ''}</p>
          <span class="book-format">${book?.fileType || ''}</span>
        </div>
      </div>
    </article>
  `;
}

export function createBookListItem(book) {
  return `
    <div class="book-list-item" data-id="${book?.id}">
      <div class="book-list-cover">
        ${book?.cover ? `<img src="${book.cover}" alt="">` : ''}
      </div>
      <div class="book-list-info">
        <h3>${book?.title || ''}</h3>
        <p>${book?.author || ''}</p>
      </div>
      <span class="book-list-progress">${Number(book?.progress ?? 0) || 0}%</span>
      <button class="book-action-btn info-book-btn" data-id="${book?.id}" title="详情">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 16v-4M12 8h.01"/>
        </svg>
      </button>
    </div>
  `;
}
